/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/3/21
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import InventoryMap from './InventoryMap';
import { selectInventoryModelsForMap } from 'selectors/entities/inventories';
import paramsAreSet from 'support/paramsAreSet';

const mapStateToProps = (state, ownProps) => {
  const { analysisType } = ownProps;
  const models = paramsAreSet(analysisType, ownProps)
    ? selectInventoryModelsForMap(state, ownProps)
    : [];

  return ({ models });
};
export default connect(mapStateToProps)(InventoryMap);



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryMap/index.js